import { Text } from '@cmpsr/components';

type RisksSectionTitleProps = {
  headline: string;
  subheadline?: string;
};

export default function RisksSectionTitle({ headline, subheadline }: RisksSectionTitleProps) {
  return (
    <Text variant="text-header-M">
      {headline}{' '}
      <Text as="span" textStyle="text-header-m-v">
        {subheadline}
      </Text>
    </Text>
  );
}
